export default {
	props:{
		id: String,
		name: String,
		value:  [ String, Number],
		options: [Object, Array],
		autocomplete: String,
		label: String, //work as label
		floatingLabel:{type:Boolean, default:false},
		defOptLabel: {type:String, default:''},
		defOptValue: {type:[Object, String, Number], default:null},
		defOptSelected:{type:Boolean, default:true},
		defOptDisabled:{type:Boolean, default:false},
		clearable: Boolean,
		disabled: Boolean,
		errorMsg: String,
	},
	data(){
		return {
			innerValue: typeof(this.value)!=='undefined'&&this.value!==null ? this.value : this.defOptValue,
			hintVisible: true,
			hasFocus: false,
			uniqueId: null,
		}
	},
	watch: {
		value:{
			immediate: true,
			handler(){
				this.innerValue = typeof(this.value)!=='undefined'&&this.value!==null ? this.value : this.defOptValue;
			},
		},
	},
	computed:{
		hasValue(){
			return this.innerValue!==this.defOptValue;
		},
		cpSelectedOption(){
			let opt = null;
			for(const i in this.options){
				if(this.options[i].value===this.innerValue){
					opt = this.options[i];
					break;
				}
			}
			return opt;
		},
		mainCssClass(){
			return ['styled-select', this.clearable?'clearable':'', this.floatingLabel?'floating-label':'', this.hasFocus?'focused':'', this.hasValue?'has-value':''];
		},
		elementId(){
			if(this.id) return this.id;
			if(this.name) return this.name.replaceAll('[','.').replaceAll(']','');
			if(this.uniqueId) return this.uniqueId;
			return '';
		}
	},
	methods: {
		setInnerValue(val){
			this.innerValue = val;
		},
		onChange(){
			let opt = this.cpSelectedOption;
			if(opt && opt.href){
				window.location.href = opt.href;
				return;
			}
			this.$emit('input', this.innerValue);
			this.$emit('change', this.innerValue);
			this.$emit('change-option', opt);
		},
		onClear(){
			this.innerValue = this.defOptValue;
			this.onChange();
			this.$emit('clear');
		},
		focus(){
			this.$refs.inputElement.focus();
		},
		blur(){
			this.$refs.inputElement.blur();
		},
		onFocus(){
			this.hasFocus = true;
			this.$emit('focus');
		},
		onBlur(){
			this.hasFocus = false;
			this.$emit('blur');
		},
	},
	mounted() {
		this.uniqueId = this._uid?'id-'+this._uid:'';
		setTimeout(()=>{
			if(this.$refs.inputElement && (this.$refs.inputElement.matches(':autofill') || this.$refs.inputElement.matches(':-webkit-autofill'))){
				this.hasFocus = true;
			}
		}, 600);
	},
	template: `
<div :class="mainCssClass">
	<label v-if="label" class="ext-label" :for="elementId">{{label}}</label>
	<select ref="inputElement" @change="onChange" v-model="innerValue" :id="elementId" :name="name" :disabled="disabled" @focus="onFocus" @blur="onBlur">
		<option v-if="defOptLabel" :value="defOptValue" :disabled="defOptDisabled" :selected="defOptSelected">{{defOptLabel}}</option>
		<option v-for="(option,index) in options" :value="option.value" :disabled="option.disabled">{{option.label}}</option>
	</select>
	<span v-if="hintVisible && errorMsg" class="hint error-msg" v-t="errorMsg"></span>
	<span v-if="clearable" :class="['qicon-1 clear-icon', this.hasValue?'active':'in-active']" @click="onClear">trash</span>
</div>
`,
}
